import { render, staticRenderFns } from "./CommonSmoothScroll.vue?vue&type=template&id=b2df7486&scoped=true&"
import script from "./CommonSmoothScroll.vue?vue&type=script&lang=js&"
export * from "./CommonSmoothScroll.vue?vue&type=script&lang=js&"
import style0 from "./CommonSmoothScroll.vue?vue&type=style&index=0&id=b2df7486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2df7486",
  null
  
)

export default component.exports